// src/features/ownerAdmin/AnnouncementsPage.tsx
import { useState, type FormEvent } from 'react';
import { useSendBroadcast } from './useCreatorData';
import './OwnerAdminPage.css';

export function AnnouncementsPage() {
  const [message, setMessage] = useState('');
  const [confirming, setConfirming] = useState(false);
  const [sentMessage, setSentMessage] = useState<string | null>(null);
  const send = useSendBroadcast();

  const valid = message.trim().length > 0 && message.length <= 1900;

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!valid) return;
    if (!confirming) { setConfirming(true); return; }

    send.mutate(message.trim(), {
      onSuccess: () => {
        setSentMessage(message.trim());
        setMessage('');
        setConfirming(false);
      },
    });
  }

  return (
    <>
      <div className="page-header">
        <p className="page-header__eyebrow">Bot owner only</p>
        <h1 className="page-header__title">Announcements</h1>
      </div>

      <article className="card">
        <header className="card__header">
          <div>
            <p className="card__eyebrow">Broadcast</p>
            <h2 className="card__title">Message All Server Owners</h2>
          </div>
        </header>
        <div className="card__content">
          <p style={{ color: 'var(--text-muted)', fontSize: 12, margin: '0 0 0.75rem' }}>
            Sends a DM to every active server&apos;s owner, via the bot. Owners who&apos;ve opted out
            (in their own Settings page) are automatically skipped — never even attempted.
          </p>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <textarea
              className="input"
              rows={5}
              maxLength={1900}
              value={message}
              onChange={(e) => { setMessage(e.target.value); setConfirming(false); }}
              placeholder="e.g. We're rolling out a new feature next week — here's what's changing..."
            />
            <p style={{ color: 'var(--text-muted)', fontSize: 11, margin: 0 }}>{message.length} / 1900</p>

            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
              <button className="button-primary" type="submit" disabled={!valid || send.isPending}>
                {send.isPending ? 'Sending…' : confirming ? 'Click again to confirm and send' : 'Send to all owners'}
              </button>
              {send.isError && <span style={{ color: 'var(--negative)', fontSize: 13 }}>Couldn&apos;t send. Try again.</span>}
            </div>

            {sentMessage && (
              <p style={{ color: 'var(--positive)', fontSize: 13 }}>
                Broadcast queued — the bot will deliver it shortly.
              </p>
            )}
          </form>
        </div>
      </article>
    </>
  );
}
